<template>
  <div class="clickable has-border__bottom item-list-dashboard" @click="click">
    <div class="file-item flex-row flex-left" style="padding: 5px 0px;">
      <i
        v-if="
          type !== DASHBBOARD_TYPE.CV_TOI_GIAO &&
          type !== DASHBBOARD_TYPE.CV_DUOC_GIAO
        "
        class="
          far
          fa-file
          color__link
          font-size__small
          margin-right-10
        "
      ></i>
      <div
        v-else
        :class="[
          'theDueDate',
          'margin-right-10',
          getDeadlineLvlClass(item.deadline),
        ]"
      ></div>
      <span
        :class="
          item.isSeen ||
          type == DASHBBOARD_TYPE.CV_TOI_GIAO ||
          type == DASHBBOARD_TYPE.CV_DUOC_GIAO
            ? 'file-name text-overflow-document'
            : 'file-name text-overflow-document font-weight__bold'
        "
        >{{ item.quote }}</span
      >
    </div>
    <span
      style="color: rgb(136, 152, 170)"
      :class="
        item.isSeen ||
        type == DASHBBOARD_TYPE.CV_TOI_GIAO ||
        type == DASHBBOARD_TYPE.CV_DUOC_GIAO
          ? 'file-name text-overflow-document'
          : 'file-name text-overflow-document font-weight__bold'
      "
    >
      {{ peopleTitle(item) }} {{ timeTitle(item) }}</span
    >
  </div>
</template>

<script>
import moment from "moment";
import constants from "../../constants";
import dateFormatter from "../../filters/dateFormatter";
export default {
  name: "doc-dashboard-card-item",
  props: ["item", "type"],
  filters: { dateFormatter },
  data() {
    return {
      DASHBBOARD_TYPE: constants.DASHBBOARD_TYPE,
    };
  },
  methods: {
    click() {
      this.$emit("click");
    },
    peopleTitle(item) {
      let title = "";
      switch (this.type) {
        case constants.DASHBBOARD_TYPE.VBDEN_CHO_XU_LY:
          title = `Từ ${item.senderName || '...'}`;
          break;
        case constants.DASHBBOARD_TYPE.VBDI_CHO_XU_LY:
          title = `Từ ${item.senderFullName || '...'}`;
          break;
        case constants.DASHBBOARD_TYPE.VB_CHO_BAN_HANH:
          title = `Từ ${item.senderFullName || '...'}`;
          break;
        case constants.DASHBBOARD_TYPE.VB_CHO_TIEP_NHAN:
          title = `Từ ${item.senderFullName || '...'}`;
          break;
        case constants.DASHBBOARD_TYPE.CV_TOI_GIAO:
          title = `Đến ${item.receiverName || '...'}`;
          break;
        case constants.DASHBBOARD_TYPE.CV_DUOC_GIAO:
          title = `Từ ${item.assignerName || '...'}`;
          break;
        default:
          title = "Từ ...";
          break;
      }
      return title;
    },
    timeTitle(item) {
      let title = "";
      switch (this.type) {
        case constants.DASHBBOARD_TYPE.VBDEN_CHO_XU_LY:
          title = `- Vào lúc: ${
            item.createTime
              ? new moment(item.createTime).format("DD/MM/YYYY HH:mm")
              : "-"
          }`;
          break;
        case constants.DASHBBOARD_TYPE.VBDI_CHO_XU_LY:
          title = `- Vào lúc: ${
            item.createTime
              ? new moment(item.createTime).format("DD/MM/YYYY HH:mm")
              : "-"
          }`;
          break;
        case constants.DASHBBOARD_TYPE.VB_CHO_BAN_HANH:
          title = `- Vào lúc: ${
            item.createTime
              ? new moment(item.createTime).format("DD/MM/YYYY HH:mm")
              : "-"
          }`;
          break;
        case constants.DASHBBOARD_TYPE.VB_CHO_TIEP_NHAN:
          title = `- Vào lúc: ${
            item.createTime
              ? new moment(item.createTime).format("DD/MM/YYYY HH:mm")
              : "-"
          }`;
          break;
        case constants.DASHBBOARD_TYPE.CV_TOI_GIAO:
          title = `- Hạn đến: ${
            item.deadline ? new moment(item.deadline).format("DD/MM/YYYY") : "-"
          }`;
          break;
        case constants.DASHBBOARD_TYPE.CV_DUOC_GIAO:
          title = `- Hạn đến: ${
            item.deadline ? new moment(item.deadline).format("DD/MM/YYYY") : "-"
          }`;
          break;
        default:
          title = "";
          break;
      }
      return title;
    },
    getDeadlineLvlClass(deadline) {
      if (!deadline) return "";
      let date = new moment(deadline).startOf("date");
      let now = new moment().startOf("date");
      let diff = date.diff(now, "days");
      return diff >= 3 ? "lv3" : diff < 3 && diff >= 0 ? "lv2" : "lv1";
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/dashboard/doc-dashboard-card-item.vue